import { render, staticRenderFns } from "./planExplanation.vue?vue&type=template&id=549cb9f6&scoped=true"
import script from "./planExplanation.vue?vue&type=script&lang=js"
export * from "./planExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549cb9f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('549cb9f6')) {
      api.createRecord('549cb9f6', component.options)
    } else {
      api.reload('549cb9f6', component.options)
    }
    module.hot.accept("./planExplanation.vue?vue&type=template&id=549cb9f6&scoped=true", function () {
      api.rerender('549cb9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/batchInsurance/components/planExplanation.vue"
export default component.exports